import React, { useEffect, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { updateCandidateSummary } from "../../../redux/actions/admin/CandidateActions";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";
import CustomHtmlEditor from "../../shared/views/CustomHtmlEditor";
import JoditEditor from "jodit-react";
import CustomAlert from '../../shared/views/CustomAlert';

let ResumeSummary = (props) => {
  const { summary, updateCandidateSummary } = props;
  const descriptionHtmlEditor = useRef();
  const [isSummaryAdding, setIsSummaryAdding] = React.useState(false);
  const [updateFailed, setUpdateFailed] = React.useState(false);
  const [published, setPublished] = useState(false);
  // const [loginFailed, setLoginFailed] = React.useState(false);
  const [newSummary, setNewSummary] = useState({
    candidateId: "",
    description: summary.description || "",
    title: summary.title || ""
  });
  const [error, setError] = React.useState("");
  useEffect(() => {
    if (summary !== null) {
      setNewSummary((prevState) => ({
        ...prevState,
        description: summary.description,
        title: summary.title,
      }));
    }
  }, [summary]);
  useEffect(() => {
    descriptionHtmlEditor.current?.focus();
  }, []);

  const handleCreateSummarySubmit = async () => {
    setIsSummaryAdding(true);
    setError("");
    const candidate = localStorageService.getItem("malibaara_auth_candidate");
    const presentation = { ...newSummary, candidateId: candidate.id };
    try {
      const data = await updateCandidateSummary(presentation);

      if (data.success) {
        setPublished(true);
      }
    } catch (error) {
      setError("Erreur lors de cette opération. Veuillez ressayer");
      console.log('error', error)
    } finally {
      setIsSummaryAdding(false);
    }

  };


  const handleSaveButtonClick = () => {
    handleCreateSummarySubmit();
  };

  const handleEditorChange = (value) => {
    setNewSummary((prevState) => ({
      ...prevState,
      description: value,
    }));
    localStorageService.setItem("presentation_summary", value);
  };

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
    }),
    []
  );

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0">
              <h3 className="title mb-0">
                <span>Présentation</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button
              className={`btn btn-primary`}
              onClick=
              {handleSaveButtonClick}
              disabled={updateFailed}
            >
              Sauvegarder &nbsp;{" "}
              {isSummaryAdding ? (
                <CircularProgress size={15} />
              ) : (
                <span></span>
              )}
            </button>
          </div>
          {error && (
            <div className="col-md-12 mt-4">
              <CustomAlert content={error} type="alert-danger" />
            </div>
          )}
          {updateFailed && (
            <div className="col-12 mt-4">
              <CustomAlert content="Email et/ou le mot de passe incorrect" type="alert-danger" />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="mt-4">
              <div className="bg-light-3">
                <div _lpchecked="1">
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label>Titre</label>
                      <input
                        value={newSummary?.title}
                        type="text"
                        className="form-control"
                        id="title"
                        onChange={(e) => {
                          let val = e.target?.value;
                          setNewSummary((prevState) => {
                            return { ...prevState, title: val };
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label>Description</label>
                      <JoditEditor
                        value={newSummary?.description}
                        onChange={handleEditorChange}
                        ref={descriptionHtmlEditor}
                        config={config}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ResumeSummary.propTypes = {
  updateCandidateSummary: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  updateCandidateSummary: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  updateCandidateSummary,
})(ResumeSummary);
